import React, { useState } from 'react';
import { Alert, Button, Modal, Steps, Tooltip, Radio, Typography } from 'antd';
import TestConnectionContent from './TestConnectionContent';
import classes from './GCPInfoModal.module.css';
const { Paragraph } = Typography;
import { connect } from 'dva';
import { isEmpty } from 'lodash';
import { decryptAES } from '@/utils/utils';
import StepComponent from '@/components/CloudAccounts/CredentialsForm/InfoSteps';
const downgradeSteps = [
  {
    text:
      'Login to Azure portal by clicking <a href="https://portal.azure.com" target="_blank">HERE</a> & select the subscription that you’ve connected with Cloudnosys.',
  },
  { text: 'Click on “Access Control (IAM)” from the left-hand side menu.' },
  { text: 'Click on “Role Assignments” option from the menu on top.' },
  {
    text:
      'In the search box, type in the App name you’ve connected your Azure account to Cloudnosys with.',
  },
  {
    text: 'Select the following roles of the connected App registration and “Delete” them:',
    list: [
      'Disk Snapshot Contributor',
      'Network Contributor',
      'Virtual Machine Contributor',
      'Storage Account Contributor',
    ],
  },
  {
    text:
      'Search for a custom role assigned to the same app registration in addition to the above mentioned roles, with the following permissions and “Delete” it, as well:',
    list: [
      'Microsoft.Resources/subscriptions/resourceGroups/write',
      'Microsoft.Resources/subscriptions/resourceGroups/delete',
    ],
  },
  {
    text:
      'Make sure that you have deleted all the role assignments from the App registration, used to connect with Cloudnosys, leaving only the “Reader” role on the App.',
  },
  {
    text: 'Once done, you will then need to delete the client secret and add a new client secret.',
  },
  {
    text:
      'Copy the new secret value and replace the secret value in your Azure cloud account on Cloudnosys platform from the Cloud Account edit screen.',
  },
  {
    text: 'Run the “Scan” button on Cloudnosys platform to perform misconfigurations scan (CSPM).',
  },
];

const DowngradeInfoSteps = () => {
  return (
    <div style={{ margin: '30px 0' }}>
      <StepComponent isEditScreen={true} heading="Update App Registration" steps={downgradeSteps} />
    </div>
  );
};

const AzureDowngradeInfoModal = props => {
  const {
    cloudAccountData,
    setDowngradeInfoModal,
    downgradeInfoModal,
    setModeCheckbox,
    dispatch,
    testConnectionTypes,
  } = props;
  const [current, setCurrent] = useState(0);

  const handleDowngradeAccount = async () => {
    // return;
    await dispatch({
      type: 'cloudAccounts/updateCloudAccountMode',
      payload: {
        cloudAccountId: cloudAccountData.id,
        protectionLevel: 'basic',
      },
    });

    const serviceAccount = JSON.parse(decryptAES(cloudAccountData.userkeys));
    const payload = {
      ...cloudAccountData,
      // serviceAccount: serviceAccount.credentials,
      protectionLevel: 'basic',
    };

    runScan(payload);
    setDowngradeInfoModal(true);
    Modal.destroyAll();
  };

  const runScan = accountData => {
    const { dispatch } = props;

    // Get currently scanning cloud accounts Ids
    let currentlyScanningCloudAccountsIds = getCurrentlyScanningCloudAccountsIds({
      shouldFilterWithStartScanStatus: true,
    });

    // Reset scan progress if currently no cloud account is scanning
    if (currentlyScanningCloudAccountsIds.length === 0) {
      dispatch({
        type: 'cloudAccount/clearScanProgress',
      });
    }

    dispatch({
      type: 'scan/runScan',
      payload: {
        cloudAccounts: [accountData],
        orgId: accountData.orgId,
        currentlyScanningCloudAccountsIds,
      },
    });

    dispatch({
      type: 'scopeReport/current',
    });
  };
  const getCurrentlyScanningCloudAccountsIds = ({ shouldFilterWithStartScanStatus = true }) => {
    const { allCloudAccountsList } = props;

    // Get currently scanning cloud accounts Ids
    const currentlyScanningCloudAccountsIds = allCloudAccountsList
      .filter(
        cloudAccount =>
          cloudAccount.status === 'running-scan' ||
          (shouldFilterWithStartScanStatus && cloudAccount.status === 'start-scan')
      )
      .map(cloudAccount => cloudAccount.id);

    return currentlyScanningCloudAccountsIds;
  };

  const steps = [
    {
      title: 'Update App Registration',
      content: (
        <>
          <DowngradeInfoSteps />
        </>
      ),
    },
    {
      title: 'Testing',
      content: (
        <TestConnectionContent
          isEditCloudAccount={true}
          cloudAccountData={cloudAccountData}
          byPassAndTestAll={true}
          // connectionProtectionType="advanced"
          connectionProtectionType="basic"
        />
      ),
    },
  ];

  const items = steps.map(item => ({
    key: item.title,
    title: item.title,
  }));

  const next = () => {
    setCurrent(current + 1);
    // updateAccountAndTestConnection();
  };
  const prev = () => {
    setCurrent(current - 1);
  };

  const handleCancel = () => {
    // setModeCheckbox(cloudAccountData.protectionLevel);
    setDowngradeInfoModal(false);
    // onUnmount();
  };

  const isAllConnectionConnected = () =>
    !isEmpty(testConnectionTypes) &&
    Object.keys(testConnectionTypes).every(key => testConnectionTypes[key].status === 200);

  const buttonsActions = [
    {
      firstBtn: 'Cancel',
      secondBtn: 'Test Connection',
      onClickFirstBtn: handleCancel,
      onClickSecondBtn: next,
      disabledSecondBtn: false,
    },
    {
      firstBtn: 'Previous',
      secondBtn: 'Finish and Run Scan',
      onClickFirstBtn: prev,
      onClickSecondBtn: handleDowngradeAccount,
      disabledSecondBtn: !isAllConnectionConnected(),
      disabledSecondBtnTooltipText: 'Please test all connections first',
    },
  ];

  return (
    <Modal
      visible={downgradeInfoModal}
      onOk={false}
      onCancel={() => {
        setModeCheckbox(cloudAccountData.protectionLevel);
        setDowngradeInfoModal(false);
      }}
      closable={false}
      bodyStyle={{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }}
      width={1000}
      destroyOnClose
      footer={[
        <Button key="back" onClick={buttonsActions[current].onClickFirstBtn}>
          {buttonsActions[current].firstBtn}
        </Button>,
        <Tooltip
          style={{
            marginLeft: '14px',
          }}
          placement="bottom"
          title={buttonsActions[current].disabledSecondBtnTooltipText}
        >
          <Button
            key="submit"
            type="primary"
            onClick={buttonsActions[current].onClickSecondBtn}
            disabled={buttonsActions[current].disabledSecondBtn}
            style={{
              marginLeft: '14px',
            }}
          >
            {buttonsActions[current].secondBtn}
          </Button>
        </Tooltip>,
      ]}
    >
      <Steps size="small" current={current} items={items} />
      {steps[current].content}
    </Modal>
  );
};

export default connect(({ cloudAccount }) => ({
  testConnectionTypes: cloudAccount.testConnectionTypes,
  allCloudAccountsList: cloudAccount.allCloudAccountsList,
}))(AzureDowngradeInfoModal);
